import React from 'react';
import {Button, Fade} from '@material-ui/core';

const FilterList = ({items, type, expandableList, renderItem, classes}) => {
	const visibleItems = expandableList.getVisibleItems(type, items);
	const isExpanded = expandableList.isExpanded(type);
	const hasMore = expandableList.shouldShowMore(items);

	return (
		<>
			<div className="list_item">
				{visibleItems.map((item, index) => (
					<Fade
						in={true}
						timeout={300}
						style={{transitionDelay: `${index * 30}ms`}}
						key={`${type}-${item.value || index}`}
					>
						<div className={`item ${classes.filterItem}`}>
							{renderItem(item, index)}
						</div>
					</Fade>
				))}
			</div>
			{hasMore && (
				<Fade in={true} timeout={300}>
					<Button
						className={classes.seeMoreButton}
						onClick={() => expandableList.toggle(type)}
						size="small"
					>
						{isExpanded
							? 'Show Less'
							: `See More (${items.length - 10} more)`}
					</Button>
				</Fade>
			)}
		</>
	);
};

export default React.memo(FilterList);